export default __webpack_public_path__ + "static/media/rectangleGroupBottomLeft.6ca5a72a.svg";